import { merge } from 'lodash-es';

export type OverflowTypes = 'auto' | 'hidden' | 'scroll' | 'visible';
export type OverflowAxisProps = {
  x?: OverflowTypes;
  y?: OverflowTypes;
};
export type OverflowProps = {
  overflow?: OverflowTypes | OverflowAxisProps;
};

const overflowCSSInternal = (overflow?: OverflowTypes, axis?: 'X' | 'Y') =>
  overflow != null ? { [axis ? `overflow${axis}` : 'overflow']: overflow } : {};

export const overflowCSS = (overflow?: OverflowTypes | OverflowAxisProps) =>
  overflow != null && typeof overflow === 'string'
    ? overflowCSSInternal(overflow)
    : merge(overflowCSSInternal(overflow?.x, 'X'), overflowCSSInternal(overflow?.y, 'Y'));

const isScrollable = (value?: OverflowTypes) => value === 'auto' || value === 'scroll';

export const hasOverflow = (overflow?: OverflowTypes | OverflowAxisProps) =>
  overflow === 'auto' ||
  overflow === 'scroll' ||
  (typeof overflow === 'object' &&
    overflow !== null &&
    (isScrollable(overflow.x) || isScrollable(overflow.y)));
